export function decodeURIComponentSafe(value: string): string {
  if (typeof value !== 'string') return value as any;

  let result = value;
  let last = null;

  while (result !== last) {
    last = result;
    try {
      result = decodeURIComponent(result);
    } catch {
      break;
    }
  }

  return result;
}

export function safeEncodeURIComponent(value: string): string {
  if (typeof value !== 'string') return value as any;

  let decoded = decodeURIComponentSafe(value);
  decoded = decoded.replace(/\uFFFD+/g, '');
  decoded = decoded.normalize('NFC');
  return encodeURIComponent(decoded);
}

export function slug(str: string): string {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = 'åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;';
  var to = 'aaaaaaeeeeiiiioooouuuunc------';

  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str
    .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes

  return str;
}

export function locationSlug(str: string): string {
  let locationSlug = slug(str || '');
  if (locationSlug === 'near-me') locationSlug = 'nara-mig';
  return locationSlug;
}
